import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.SplitViewWrapper.RequestCapturePromotion', {
    title: 'Extract data from images and PDFs in seconds with ApprovalMax Capture — no manual entry needed.',
    description: '100 free documents',
    tryNowButtonText: 'Start automating',
});
